import {EntityWithAuditMetadata} from "../../../modules/common/entity/entityWithAuditMetadata";

export class BaseAuditableDto extends EntityWithAuditMetadata {
}